.mvAside {
    width: 100%;
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    transform: translateX(100%);
    transition: transform 0.3s ease-in-out;
    background-color: #fff;
    z-index: 9999;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    filter: drop-shadow(-2px 1px 8px rgba(0, 0, 0, 0.25));

    &.open {
        transform: translateX(0);
    }

    @media screen and (min-width: 768px) {
        width: 50%;
    }
}

.mvAsidePanelHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #dfdfdf;
    padding: 0.4rem 0.5rem 0.4rem 1rem;
    flex-shrink: 0;

    h2 {
        margin: 0;
        padding: 0.6rem 0;
    }
}

.mvAsidePanelBody {
    padding: 0 1rem;
    flex-grow: 1;
    overflow: auto;
}

.mvAsidePanelFooter {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    flex-grow: 0;
    padding: 1rem;
    border-top: 1px solid #dfdfdf;
}

.addressLimitMessage {
    color: #cb0000;
    font-size: 0.85rem;
    padding-right: 1rem;
}

.mvAsidePanelAddressGroup {
    padding-bottom: 1rem;

    > h3 {
        margin-bottom: 0.5rem;
        font-size: 1rem;
    }
    table {
        font-size: 0.75rem;
        display: flex;
        flex-direction: column;
        align-items: stretch;

        tr {
            display: flex;
            flex-direction: row;
            align-items: stretch;
            align-content: center;
            border-bottom: 1px solid #dfdfdf;

            td:first-child,
            th:first-child {
                padding-left: 0;
            }

            td:nth-child(2),
            th:nth-child(2) {
                text-align: left;
                padding-left: 0.5rem;
            }

            &:last-child {
                border-bottom: 0;
            }
        }

        td,
        th {
            padding: 0.3rem;
            &:last-child {
                margin-left: auto;
            }
        }
    }
}

.zipcodeArea {
    min-width: 5.3rem;
}

.mvPanelCloseButton {
    appearance: none;
    border: 0;
    cursor: pointer;
    padding: 1rem;
    background-color: transparent;
    outline: 0;
    box-shadow: none;
    color: #222222;
}

.mvPanelCloseIcon {
    width: 12px;
}

.mvAsidePanelConfirmButton {
    margin-left: auto;
    flex-shrink: 0;
}

.selectedMessage {
    display: block;
    text-align: right;
    padding: 0.3rem;
    border-radius: 0.2rem;
    font-weight: 600;
    background-color: #14456b22;
    font-size: 0.825rem;
    color: #14456b;
}
